// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__38s0t","addWidgetButton":"Header_addWidgetButton__3G26x","dashboardTabs":"Header_dashboardTabs___Ztrn","active":"Header_active__3whbN"};